export default class BooleanUtils {
    static getIsAllFalse(list: boolean[]): boolean {
        for (const value of list) {
            if (value) return false;
        }

        return true;
    }
}